module.exports = __webpack_public_path__ + "img/no1phone.9758052b.png";